export const TABS = {
  USER: 'user',
  PUBLIC: 'public',
}

export const CHAR_LIMITS = {
  user: 90,
  public: 100,
}

export const COLORS = [
  '', '#ffffff', '#000000', '#e60000', '#ff9900', '#ffff00',
  '#008a00', '#0066cc', '#9933ff', '#ffc107', '#ff6600',
  '#ff0000', '#00b0f0', '#7030a0', '#70ad47', '#ed7d31',
]

export const FONT_SIZES = ['12px', '13px', '14px', '15px', '16px', '17px', '18px', '20px', '22px', '24px', '28px', '32px']

// Toolbar container shared by both editors; handlers are wired per-editor inside the component.
export const TOOLBAR_CONTAINER = [
  ['bold', 'italic', 'underline', 'strike'],
  [{ color: COLORS }, { background: COLORS }],
  [{ size: FONT_SIZES }],
  ['link', 'clean'],
]

export const QUILL_FORMATS = [
  'bold', 'italic', 'underline', 'strike',
  'color', 'background',
  'size',
  'link',
]

export const TOOLTIP_MAP = {
  'ql-bold': 'Bold',
  'ql-italic': 'Italic',
  'ql-underline': 'Underline',
  'ql-strike': 'Strikethrough',
  'ql-color': 'Text Color',
  'ql-background': 'Background Color',
  'ql-size': 'Font Size',
  'ql-link': 'Insert Link',
  'ql-clean': 'Remove Formatting',
}

export const initialUserState = {
  message: '',
  dismissable: true,
  closeBtnColor: '',
  bgColor: '',
}

export const initialPublicState = {
  message: '',
}
